interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: (number | string)[] = [];
  const push = (p: number | string) => pages.push(p);

  if (total <= 7) {
    for (let i = 1; i <= total; i += 1) push(i);
  } else {
    push(1);
    if (current > 3) push("...");
    for (let i = Math.max(2, current - 1); i <= Math.min(total - 1, current + 1); i += 1) push(i);
    if (current < total - 2) push("...");
    push(total);
  }

  return (
    <nav className="flex items-center justify-center gap-2 mt-10" aria-label="分页">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="w-9 h-9 flex items-center justify-center rounded-md border border-background-200 text-foreground-700 hover:border-primary-400 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line" aria-hidden="true"></i>
      </button>
      {pages.map((p, idx) =>
        typeof p === "number" ? (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={`w-9 h-9 flex items-center justify-center rounded-md text-sm font-medium cursor-pointer transition-colors ${
              p === current
                ? "bg-primary-500 text-background-50"
                : "border border-background-200 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
            }`}
          >
            {p}
          </button>
        ) : (
          <span key={`dot-${idx}`} className="w-9 h-9 flex items-center justify-center text-foreground-400">
            {p}
          </span>
        ),
      )}
      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className="w-9 h-9 flex items-center justify-center rounded-md border border-background-200 text-foreground-700 hover:border-primary-400 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
      </button>
    </nav>
  );
}